








































import Vue from 'vue';
import router from '@/router/index'; 

export default Vue.extend({
    name: 'TheCalender',
    data(){
        return {
            items: [] as Date[],
            dayName: [
                "Su",
                "Mo",
                "Tu",
                "We",
                "Th",
                "Fr",
                "Sa",
            ],
            monthName: [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December",
            ],
            calenderDateArr:[
                { id: 0, txt:"", dateStr:"", isCurrDate: false, isCurrSelectedDate: false, hasEvent: false },
            ],
            displayMonth:-1,
            displayYear:-1,
            selectedMonth: -1,
            selectedYear: -1,
            selectedDate: -1,
        }
    },
    mounted: function() {
        this.setCurrentSelectionToCurrDate();
        this.calculateDates();
    },
    methods: {
        eventListReader: function(){
            return fetch(`${this.$server_address}/GetAllEventDetails`,
            {
                method: "GET",
                credentials: 'include',
            })
            .then(
                  function(res){ 
                    if (res.status === 401) {
                        router.push({ name: 'Login'});
                        throw new Error('Unauthorize');
                    }
                    if (res.status === 200) {
                        return res.json();
                    } 
                }
            )
            .then(
                (data) => {
                    this.items = [];
                    for(var x = 0; x < data.length ; x++){
                          if(!data[x].eventId){
                            continue;
                        }
                        
                        if(!data[x].eventName){
                            continue;
                        }
                        
                        //if(!data[x].createdBy){
                        //    continue;
                        //}

                        //if(!data[x].latestUpdateTimestamp){
                        //    continue;
                        //}

                        if(!data[x].namefacilitatorspresentersspeakers){
                            continue;
                        }

                        if(!data[x].eventOrgId){
                            continue;
                        }

                        if(!data[x].eventTypeId){
                            continue;
                        }           

                        if(!data[x].eventStartTime){
                            continue;
                        }

                        if(!data[x].eventEndTime){
                            continue;
                        }

                        if(data[x].eventStartTime){
                            var startdatetime = new Date(data[x].eventStartTime);
                            //var year = startdatetime.getFullYear();
                            //var month = startdatetime.getMonth()+1;
                            //var day = startdatetime.getDate();

                            var normalizeDate = new Date(startdatetime.getFullYear(), startdatetime.getMonth(), startdatetime.getDate(), 0, 0, 0);
                            this.items.push(normalizeDate);                    
                        }
                    }
                    this.items.sort(); // Sort date to ascending
                    this.items = this.items.filter(function(item, pos, ary) {
                        if(!ary[pos - 1]){
                            return true; // Pass for first array
                        }

                        if(item.getTime() == ary[pos - 1].getTime()){
                            return false;
                        }
                        else{
                            return true;
                        }
                    }); //Remove duplicate dates

                    //console.log( this.items)
                } 
            )

            //this.items = this.$store.state.event_list;
        },
        currentDateStyle: function(var_isSelected:boolean){
            if(var_isSelected)
                return `currDateHighlight`
            else
                return ``
        },
        currentSelectionDateStyle: function(var_isSelected:boolean){
            //console.log("HERE");
            if(var_isSelected)
                return `selectedDateHighlight`
            else
                return ``
                
        },
        setCurrentSelectionToCurrDate: function(){
            var currDateObj = new Date();
            var currYear = currDateObj.getFullYear();
            var currMonth = currDateObj.getMonth();

            this.displayMonth = currMonth + 1;
            this.displayYear = currYear

        },
        calculateDates: async function(){
            await this.eventListReader();
            var currDateObj = new Date();
            var currYear = currDateObj.getFullYear();
            var currMonth = currDateObj.getMonth();
            var currDate = currDateObj.getDate();

            var dateObj = new Date(this.displayYear, this.displayMonth - 1, 1);
            var firstDayOfCurrDisplayMonth = dateObj.getDay();
            var lastDateOfCurrDisplayMonth = new Date(this.displayYear, this.displayMonth, 0);
            var numberOfDay = lastDateOfCurrDisplayMonth.getDate();

            var totalArrLoop = numberOfDay + firstDayOfCurrDisplayMonth;

            var divisable = 7;
            var totalArrLoop_div = Math.floor(((totalArrLoop / divisable) + 1)) * divisable;
            var currentCounter = 1;

            this.calenderDateArr = [];
            var isCurrDateTemp = false;
            var isselectedDateTemp = false;
            for(var x = 0; x<totalArrLoop_div; x++){
                isCurrDateTemp = false;
                isselectedDateTemp = false;
                if(x < firstDayOfCurrDisplayMonth){
                    this.calenderDateArr.push({id: x, txt: " ", dateStr: "", isCurrDate:false,isCurrSelectedDate:false,hasEvent:false});
                }else if(x < totalArrLoop){
                    if(currYear == this.displayYear && currMonth == this.displayMonth - 1 && currDate == currentCounter){
                        isCurrDateTemp=true;
                    }
                    if(this.displayYear == this.selectedYear && this.displayMonth - 1  == this.selectedMonth - 1 && currentCounter == this.selectedDate){
                        isselectedDateTemp=true;
                    }

                    var normalizeDate = new Date(this.displayYear, this.displayMonth - 1, currentCounter, 0, 0, 0);
                    var found_date = false;
                    for(var z = 0 ; z < this.items.length; z++){
                        //console.log("=====")
                        //console.log(normalizeDate)
                        //console.log(this.items[z])
                        if(normalizeDate.getTime() == this.items[z].getTime()){
                            found_date = true;
                            //console.log("Same")
                            break;
                        }
                    }
  

                    this.calenderDateArr.push({
                        id: x, 
                        txt: currentCounter.toString(), 
                        dateStr: `${this.displayYear}-${this.displayMonth}-${currentCounter.toString()}`,
                        isCurrDate: isCurrDateTemp,
                        isCurrSelectedDate: isselectedDateTemp,
                        hasEvent:found_date
                    });
                    currentCounter++;
                }else{
                    this.calenderDateArr.push({id: x, txt: " ", dateStr: "", isCurrDate:false,isCurrSelectedDate:false,hasEvent:false});
                }
            }

            
            //console.log(this.calenderDateArr );
        },
        handler_downMonth: function(){
            if(this.displayMonth <= 1){
                this.displayMonth = 12;
                this.displayYear -= 1;
            }else{
                this.displayMonth -= 1;
            }
            this.calculateDates();

        },
        handler_upMonth: function(){
            if(this.displayMonth >=12){
                this.displayMonth = 1;
                this.displayYear += 1;
            }else{
                this.displayMonth += 1;
            }
            
            this.calculateDates();
        },
        handler_selectDate: function(var_date:string){
            //console.log(var_date);
            var splitStr = var_date.split('-');
            var year = parseInt(splitStr[0]);
            var month = parseInt(splitStr[1]);
            var date = parseInt(splitStr[2]);

            let formattedDate = date.toLocaleString('en-US', {
                minimumIntegerDigits: 2,
                useGrouping: false
            });

            let formattedMonth = month.toLocaleString('en-US', {
                minimumIntegerDigits: 2,
                useGrouping: false
            });


            var stringDate = `${year}-${formattedMonth}-${formattedDate}`

            this.selectedYear = year;
            this.selectedMonth = month;
            this.selectedDate = date;

            //this.$store.commit('update_filteredDateSelection',`${stringDate}T00:00:00`);
            this.$store.commit('update_filteredDateSelection',{start:`${stringDate}T00:00:00`,end:`${stringDate}T23:59:59`});

            this.calculateDates();
            //console.log("this.selectedMonth");
            //console.log(this.selectedMonth);
            //console.log("this.selectedYear");
            //console.log(this.selectedYear);
            //console.log("this.selectedDate");
            //console.log(this.selectedDate);
        }
    },
});
